import React from 'react';
const FAQS = [{
  q: '¿Necesito capacitación para usarlo?',
  a: 'No. Cada ficha tiene instrucciones para el profesional antes de la consigna para el paciente. Empezás desde el primer día.'
}, {
  q: '¿Sirve para todas las edades?',
  a: 'Sí. Desde los 4 años hasta adultos. Cada módulo tiene fichas diferenciadas para niños adolescentes y adultos.'
}, {
  q: '¿Está adaptado a Argentina?',
  a: 'Completamente. El lenguaje los ejemplos y los contextos son argentinos.'
}, {
  q: '¿Cuántas veces puedo imprimir?',
  a: 'Las veces que necesites. Para todos tus pacientes. De por vida.'
}, {
  q: '¿Qué pasa si no es lo que esperaba?',
  a: 'Tenés 7 días de garantía total. Si no cambia la manera en que organizás tus sesiones te devolvemos el 100% sin preguntas.'
}];
export function FAQ() {
  return <section className="flex flex-col gap-8 py-12 border-t border-stone-200" data-id="element-35">
      <h3 className="font-serif text-3xl font-bold text-[#0F4C3A] text-center" data-id="element-36">
        Preguntas frecuentes
      </h3>

      <div className="flex flex-col gap-6" data-id="element-37">
        {FAQS.map((faq, idx) => <div key={idx} className="flex flex-col bg-white p-6 rounded-xl shadow-sm border border-stone-200 gap-3 text-center" data-id="element-38">
            <h4 className="font-bold text-xl text-stone-900" data-id="element-39">{faq.q}</h4>
            <p className="text-stone-700 text-lg" data-id="element-40">{faq.a}</p>
          </div>)}
      </div>
    </section>;
}